import angular from 'angular';

import RwPrivacyPolicyComponent from './rw-privacy-policy-component';
import { RwPrivacyPolicyController } from './rw-privacy-policy-controller';
import rwPrivacyPolicyDialogModule from './components/rw-privacy-policy-dialog-module'


export default angular
  .module('rw-privacy-policy', [rwPrivacyPolicyDialogModule.name])
  .controller('RwPrivacyPolicyController', RwPrivacyPolicyController)
  .component('rwPrivacyPolicy', RwPrivacyPolicyComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/rw-privacy-policy-module.js